<template>
  <div class="app">
    <div class="title">{{object.bt}}</div>
    <div style="padding: 0 12px; margin-bottom: 60px">
      <a class="iphone" :href="'tel:'+object.lxdh" ref="telPhone">联系电话：{{object.lxdh}}</a>
      <div class="desc"><span class="fbr">地址：{{object.dz||'--'}}</span></div>
      <div v-html="object.nr" class="h5-html"  style="font-size:14px"></div>
      <div class="tplist">
        <img v-for="(item,index) in object.imgUrl2" :key="index" :src="item" alt="" class="image"  @click="preViewImg(item)"/>
      </div>
      <div  v-if="object.status=='02'&&object.clyj" class="clyj-div"><span >处理意见：{{object.clyj}}</span></div>
      <div v-if="object.status=='03'||object.status=='04'" class="sjtm">
        <p>发布时间：{{object.fbsj}}</p>
        <p>到期时间：{{object.gqsj}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      downOption: {
        auto: false, //是否在初始化后,自动执行downCallback; 默认true
      },
      title: '',
      params:this.$route.query,
      object:{},
      richImages:[],
      html:'',
    }
  },
  created() {
   
  },
  mounted() {
    console.log("详情",this.$store.state.wallView);
    this.object = this.$store.state.wallView
    this.object.fmtp ? this.object.imgUrl = this.object.fmtp : ""
    this.object.tp ? this.object.imgUrl2 = this.object.tp.split(',') : ""
  },
  methods: {
      preViewImg(img){
      let arr = [img];
      ImagePreview(arr);
    }
    
  },
}
</script>

<style lang="less" scoped>
/*说明*/
.title {
  line-height: 30px;
  text-align: left;
  padding: 0px 12px;
}
// .app /deep/ img{
//   max-width: 100%;
//   max-height: 400px;
// }
.desc {
  color: #696969;
  margin: 0px 0px;
  font-size: 14px;
}
.iphone{
  display: flex;
  align-items: center;
  margin: 2px 0px;
  color: #3e78f7;
  font-size: 14px;
  img{
    width: 16px;
    margin: 0px 4px 0px 0px;
  }
}
.fbr {
  margin-right: 8px;
}

.time {
  margin-left: 8px;
}

.content {
  color: #303133;
  text-indent: 2em;
  line-height: 22px;
}

.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}
.h5-html{
  width: 100%;
  margin: 10px 0px;
}

.image{
  width: 100%;
  height: auto;
}
.tplist{
  display: flex;
  flex-wrap: wrap;
  img{
    width: 100%;
    margin-bottom: 10px;
  }
}
.sjtm{
  font-size: 14px;
  p{
    margin: 0px;
    color: #696969
  }
}

.clyj-div{
  font-size: 14px;
  color: #000;
  border-top: 1px solid #dedede;
  padding-top: 12px;
  font-weight: bold;
}
</style>
